module.exports = __webpack_public_path__ + "media/pdfs/interior_terms-ac4e25ee582b5c918a0b5f7b5cd52b05.pdf";